import { Col, Row } from 'reactstrap';
import { TwoLayoutInfoProps } from '../constants/interface/interface';

const TwoLayoutInfo = ({ image, para1, para2 }: TwoLayoutInfoProps) => {
  return (
    <>
      <Row className="justify-content-center align-items-center">
        <Col
          lg={{ size: 5, order: 1 }}
          sm={{ size: 12, order: 2 }}
          xs={{ size: 12, order: 2 }}
          className="p-lg-0"
        >
          <div className="twolayout-img-container" data-aos="fade-right">
            <div className="twolayout-img">
              <img src={image} alt="section-img" />
            </div>
          </div>
        </Col>
        <Col
          lg={{ size: 7, order: 2 }}
          sm={{ size: 12, order: 1 }}
          xs={{ size: 12, order: 1 }}
          className="p-lg-0"
        >
          <div className="twolayout-cnt-container" data-aos="fade-left">
            <p className="twolayout-imgcnt-1">{para1}</p>
            <p>{para2}</p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default TwoLayoutInfo;
